<template>
    <div class="relative inline-flex" @mouseenter="show = true" @mouseleave="show = false">
        <!-- Circle Button: 44×44px, bg:#072551, padding:10px – 1:1 Figma -->
        <button
            type="button"
            class="w-11 h-11 rounded-full flex items-center justify-center flex-shrink-0 hover:opacity-80 transition-opacity"
            style="background-color: #072551; padding: 10px"
            :aria-label="title"
        >
            <!-- Info Icon aus Figma (24×24, fill:white) -->
            <img :src="$asset('/hkcm/icons/landing/info.svg', 'public')" alt="Info" class="w-6 h-6" />
        </button>

        <!-- Tooltip -->
        <Transition name="tooltip">
            <div
                v-if="show && title"
                class="absolute z-50 bottom-[calc(100%+8px)] left-1/2 -translate-x-1/2 w-max max-w-[240px] bg-[#031837] text-white text-sm rounded-xl px-4 py-3 shadow-lg pointer-events-none"
            >
                <!-- Pfeil -->
                <span class="absolute top-full left-1/2 -translate-x-1/2 border-4 border-transparent border-t-[#031837]" />
                {{ title }}
            </div>
        </Transition>
    </div>
</template>

<script setup>
import { ref } from 'vue';

defineProps({
    title: {
        type: String,
        default: ''
    }
});

const show = ref(false);
</script>

<style>
.tooltip-enter-active,
.tooltip-leave-active {
    transition:
        opacity 0.15s ease,
        transform 0.15s ease;
}
.tooltip-enter-from,
.tooltip-leave-to {
    opacity: 0;
    transform: translateX(-50%) translateY(4px);
}
.tooltip-enter-to,
.tooltip-leave-from {
    opacity: 1;
    transform: translateX(-50%) translateY(0);
}
</style>
